<template lang="">
  <div class="bbs_write">
    <table class="bbs_tbl">
      <colgroup>
        <col style="width:140px">
        <col style="width:auto">
      </colgroup>
      <tbody>
        <tr>
          <th scope="row">구분</th>
          <td>
            <div class="item">
              <span class="ui_chkbox primary lgray">
                <input type="radio" :value="null" v-model="parentSeq">
                <label><span class="txt">없음 (최상위)</span></label>
              </span>
              <span class="ui_chkbox primary lgray" v-for="parent in campaignCategoryParentList" :key="parent.seq">
                  <input type="radio" :value="parent.seq" v-model="parentSeq">
                  <label><span class="txt">{{ parent.name }}</span></label>
              </span>
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row">카테고리명</th>
          <td>
            <div class="item">
              <input type="text" class="i_txt type_full lineless" placeholder="카테고리명을 입력하세요." v-model="name">
            </div>
          </td>
        </tr>
        <!-- <tr>
            <th scope="row">정렬 순서</th>
            <td>
                <div class="item">
                    <input type="number" class="i_txt" placeholder="숫자만 입력" v-model.number="sortOrder">
                </div>
            </td>
        </tr> -->
        <tr>
          <th scope="row">사용여부</th>
          <td>
            <div class="item">
                <span class="ui_chkbox primary lgray untxt">
                    <input type="checkbox" v-model="isActive">
                    <label></label>
                </span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="bbs_controller">
    <div class="rgt_area">
      <button type="button" class="bt_base primary large_h" @click="createCampaignCategory">등록</button>
      <button type="button" class="bt_base gray large_h" @click="toList">취소</button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';


const adminCampaignCategoryModule = 'adminCampaignCategoryModule'

export default {
  data() {
    return {
        parentSeq: null,
        name: '',
        sortOrder: 0,
        isActive: false
    }
  },

  methods: {
    ...mapActions(adminCampaignCategoryModule, [
      'requestCampaignCategoryParentList',
      'requestCreateCampaignCategory'
    ]),

    toList () {
      this.$router.push({ name: "CampaignCategoryManageListPage" })
    },

    async createCampaignCategory () {
      if (!this.name.trim()) {
        alert('카테고리명을 입력하세요.');
        return;
      }

        const payload = {
            name: this.name,
            parentSeq: this.parentSeq,
            sortOrder: this.sortOrder,
            isActive: this.isActive,
        };

      const isSuccess = await this.requestCreateCampaignCategory(payload);

      if (isSuccess) {
        alert('캠페인 카테고리가 등록됐습니다.');
        this.toList();
      } else {
        alert('카테고리 등록에 실패했습니다.');
      }
    }
  },

  computed: {
    ...mapState(adminCampaignCategoryModule, ['campaignCategoryParentList'])
  },

  mounted() {
    this.requestCampaignCategoryParentList()
  }
}
</script>
<style lang="">

</style>